import { FormImageComponent } from 'src/features/generalForms/builder/types/Image';
import { RPDF } from 'src/features/report/react-pdf';

export const ImageBlock: FormImageComponent = () => {
  return <RPDF.View />;
};
